export default "__VITE_ASSET__CqatcuM5__"